import styled from "styled-components";
import { SquareArrowOutUpRight } from "lucide-react";

export const PlanAndBillingContainer = styled.div`
  .plan-wrapper {
    margin-bottom: 32px;
  }
  h2 {
    margin-bottom: 5px;
  }

  .receipt-container {
    background: ${({ theme }) => theme.card.bg.secondary};
    border-radius: 10px;
    overflow: hidden;
    border: 1px solid #e9eaeb;

    .header-wrapper {
      padding: 20px 20px 16px;
      border-bottom: 1px solid #e9eaeb;

      h2 {
        font-size: 14px;
        font-weight: 500;
        color: #181d27;
        font-family: "Geist", sans-serif;
        margin-bottom: 0px;
      }
    }

    .billing-history-wrapper {
      overflow: hidden;
      .table-container {
        border-radius: 0px;
      }
      .table-wrapper {
        border-radius: 0px;
      }
      tr {
        th {
          text-align: start;
        }
      }

      .table-cell {
        color: ${({ theme }) => theme.card.font.tertiary};
      }
    }
  }

  .feature-table-wrapper {
    margin-top: 30px;
    padding: 15px;

    .table-container {
      max-height: 100%;
      .table-wrapper {
        thead {
          tr {
            background-color: transparent;

            th {
              color: ${({ theme }) => theme.card.font.tertiary};
              font-size: 20px;
              font-weight: 500;

              .header-content {
                display: flex;
                justify-content: center;
              }

              &:nth-child(1) {
                .header-content {
                  justify-content: start;
                }
              }

              &:last-child {
                color: #048af5;
              }
            }
          }
        }

        .table-cell {
          border: 0px;
          text-align: center;

          &:nth-child(1) {
            text-align: left;
            padding-left: 24px;
          }
        }

        &.table > tbody {
          vertical-align: middle;
          width: 100%;

          tr {
            padding: 30px;
            &:nth-child(odd) {
              background-color: ${({ theme }) => theme.tab.color.quaternary};
              text-transform: capitalize;
              td {
                &:first-child {
                  border-top-left-radius: 26px;
                  border-bottom-left-radius: 26px;
                }

                &:last-child {
                  border-top-right-radius: 26px;
                  border-bottom-right-radius: 26px;
                }
              }
            }

            &:nth-child(even) {
              &:hover {
                background-color: transparent;
              }
            }
          }
        }
      }
    }
  }

  @media (max-width: 1600px) {
    .row [class*="col-xl"] {
      width: 100%;
    }
  }

  @media (max-width: 768px) {
    .plan-wrapper h2 {
      font-size: 18px;
    }
  }

  @media (max-width: 576px) {
    .plan-wrapper .available-plan-wrapper {
      flex-direction: column;
    }
  }
`;

export const InvoiceCell = styled.span`
  font-size: 14px;
  color: #181d27;
  font-family: "Geist", sans-serif;
  font-weight: 500;
`;

export const TableCellWrapper = styled.div`
  font-size: 14px;
  font-weight: 400;
  font-family: "Geist", sans-serif;
  color: #0a0d1299;
`;

export const StatusCell = styled.span`
  font-size: 12px;
  font-weight: 500;
  font-family: "Geist", sans-serif;
  color: ${({ status }) => (status === "paid" ? "#276E38" : "#A23B33")};
  border: 1px solid
    ${({ status }) => (status === "paid" ? "#C5EDCE" : "#F6D5D2")};
  background-color: ${({ status }) =>
    status === "paid" ? "#F2FBF4" : "#FCF5F4"};
  padding: 2px 8px;
  border-radius: 9999px;
`;

export const ViewDetailsLink = styled.div`
  font-size: 14px;
  text-decoration: underline;
  cursor: pointer;
`;

export const SquareArrowOutUpRightIcon = styled(SquareArrowOutUpRight)`
  width: 16px;
  height: 16px;
  color: #a4a7ae;
`;
